import { transparentTag as css } from '@tencent/exeditor3-core';
export const styles = css `
  .ex-fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    overflow: auto;
  }
  .ex-lockscroll {
    overflow: hidden;
  }
`;
//# sourceMappingURL=styles.js.map